import { render, staticRenderFns } from "./deptTree.vue?vue&type=template&id=24d78ae0&"
import script from "./deptTree.vue?vue&type=script&lang=js&"
export * from "./deptTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports